import { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useMoralis } from 'react-moralis';
import { SecondaryNavigation } from '../../components/SecondaryNavigation/secondarynav';
import './login.css';

export const Login = () => {
    
    const { login, hasAuthError, isAuthUndefined, isAuthenticated, Moralis, isWeb3Enabled, enableWeb3 } = useMoralis();
    const [signUpVisible, setSignUpVisible] = useState(false);
    const [emailRecoveryVisible, setEmailRecoveryVisible] = useState(false);
    const [userName, setUserName] = useState('');
    const [userEmail, setUserEmail] = useState('');
    const [userPassword, setUserPassword] = useState('');
    const [confirmUserPassword, setConfirmUserPassword] = useState('');
    const [showAlert, setShowAlert] = useState(false);
    const [alertMsg, setAlertMsg] = useState('');
    const [showSuccess, setShowSuccess] = useState(false);
    const [successMsg, setSuccessMsg] = useState('');

    useEffect(()=>{
        if(!isWeb3Enabled) enableWeb3();
        if(isAuthenticated) return <Navigate to="/whitelist"/>;
    // eslint-disable-next-line
    },[isAuthenticated, enableWeb3, isWeb3Enabled])

    const handleSignUpForm = async () => {
        if(userName !== '' &&userEmail !== '' && userPassword!=='' && confirmUserPassword!==''){
            setAlertMsg("");
            setShowAlert(false);
            if(userPassword!==confirmUserPassword) {
                setAlertMsg("Please check your password matches.");
                setShowAlert(true);
                return;
            };
            const user = new Moralis.User();
            user.set("username", userName);
            user.set("password", userPassword);
            user.set("email", userEmail);
            user.set("whitelisted", false);
            try {
                await user.signUp();
                setSuccessMsg("User registration successful! Please check your email to validate your account.");
                setShowSuccess(true);
            } catch (error) {
                setAlertMsg("Error: " + error.message);
                setShowAlert(true);
            }

        }else{
            setAlertMsg("Please complete all the fields and try again");
            setShowAlert(true);
        }
    }

    const handleLogin = async () => {
        if(userEmail !== '' && userPassword !==''){
            setShowAlert(false);
            setAlertMsg("");
            try {
                login(userEmail, userPassword);
                if(hasAuthError && !isAuthUndefined){
                    setAlertMsg("Invalid username/password");
                    setShowAlert(true);
                }
            } catch (error) {
                setAlertMsg("Error: " + error.message);
                setShowAlert(true);
            }
        }else{
            setAlertMsg("Please complete all the fields and try again");
            setShowAlert(true);
        }
    };

    const handleReset = () => {
        if (userEmail !== '') {
          Moralis.User.requestPasswordReset(userEmail)
            .then(() => {
                setSuccessMsg("Successfully sent password recovery email");
                setShowSuccess(true);
            })
            .catch((error) => {
                setAlertMsg("Error: " + error.message);
                setShowAlert(true);
            });
        } else {
            setAlertMsg("Please complete all the fields and try again");
            setShowAlert(true);
        }
    };

    const renderSuccess = () => {
        if(successMsg!=='') return <div className='login-alert success'>{successMsg}</div>
        return <div className='login-success'>Success!</div>
    }

    const renderAlert = () => {
        if(alertMsg!=='') return <div className='login-alert'>{alertMsg}</div>
        return <div className='login-alert'>Please complete all the fields and try again</div>
    }

    const renderForms = () => {
        if(!isAuthenticated){
            if(emailRecoveryVisible){
                return  <div className="user_card">
                            <h2>Reset Password</h2>
                            { showAlert && renderAlert() }
                            { showSuccess && renderSuccess() }
                            <div className="form_container">
                                <form id="passwordResetForm">
                                    <input type="email" name="email" autoComplete="username" className="form-control input_user" value={userEmail} onChange={(e)=>{setUserEmail(e.target.value)}} placeholder="Email" />
                                    <br/>
                                    <button type="button" name="button" className="btn login_btn" onClick={handleReset}>Send Password Recovery Email</button>
                                </form>
                            </div>
                            <br/>
                            <div className="links">
                                <div>
                                    Already have an account? <button onClick={()=>{setEmailRecoveryVisible(false);setSignUpVisible(false)}}>Login</button>
                                </div>
                                <div>
                                    Don't have an account? <button onClick={()=>{setEmailRecoveryVisible(false);setSignUpVisible(true)}}>Sign Up</button>
                                </div>
                            </div>
                        </div>
            }
            if(signUpVisible){
                return  <div className="user_card">
                            <h2>Sign Up</h2>
                            { showAlert && renderAlert() }
                            { showSuccess && renderSuccess() }
                            <div className="form_container" style={{display: `${showSuccess ? "none" : "block"}`}}>
                                <form id="signUpForm">
                                    <input type="name" name="name" className="form-control input_user" value={userName} onChange={(e)=>{setUserName(e.target.value)}} placeholder="Full Name" />
                                    <br/>
                                    <input type="email" name="email" className="form-control input_user" value={userEmail} onChange={(e)=>{setUserEmail(e.target.value)}} placeholder="Email" />
                                    <br/>
                                    <input type="password" name="password" className="form-control input_pass" value={userPassword} onChange={(e)=>{setUserPassword(e.target.value)}} placeholder="Password" />
                                    <br/>
                                    <input type="password" name="confirm-password" className="form-control input_pass" value={confirmUserPassword} onChange={(e)=>{setConfirmUserPassword(e.target.value)}} placeholder="Confirm Password" />
                                    <br/>
                                    <button type="button" name="button" className="btn login_btn" onClick={handleSignUpForm}>Sign Up</button>
                                </form>
                            </div>
                            <br/>
                            <div className="links">
                                <div>
                                    Already have an account? <button onClick={()=>{setSignUpVisible(false)}}>Login</button>
                                </div>
                                <div>
                                    <button onClick={()=>{setEmailRecoveryVisible(true)}}>Forgot your password?</button>
                                </div>
                            </div>
                        </div>
            }else{
                return  <div className="user_card">
                            <h2>Login</h2>
                            { showAlert && renderAlert() }
                            <div className="form_container">
                                <form id="LogInForm">
                                    <input type="email" name="email" autoComplete="username" className="form-control input_user" value={userEmail} onChange={(e)=>{setUserEmail(e.target.value)}} placeholder="Email" />
                                    <br/>
                                    <input type="password" name="current-password" autoComplete="current-password" className="form-control input_pass" value={userPassword} onChange={(e)=>{setUserPassword(e.target.value)}} placeholder="Password" />
                                    <br/>
                                    <button type="button" name="button" className="btn login_btn" onClick={handleLogin}>Sign In</button>
                                </form>
                            </div>
                            <br/>
                            <div className="links">
                                <div>
                                    Don't have an account? <button onClick={()=>{setSignUpVisible(true)}}>Sign Up</button>
                                </div>
                                <div>
                                    <button onClick={()=>{setEmailRecoveryVisible(true)}}>Forgot your password?</button>
                                </div>
                            </div>
                        </div>
            }
        }else{
            return <Navigate to="/whitelist" replace />
        }
    }
    return (
        <>
        <SecondaryNavigation />
        <div id="login" className='text-center'>
            <div className='container'>
                <div className='section-title'>
                    {renderForms()}
                </div>
            </div>
        </div>
        </>
    )
}